import { Component, OnInit } from '@angular/core';
import { ITdDynamicElementConfig, TdDynamicElement, TdDynamicType } from '@covalent/dynamic-forms';
import { TdFileService, IUploadOptions } from '@covalent/core';
import { SupplierService } from '../supplier.service';
import { LocationService } from 'services/location.service';
import { TdLoadingService } from '@covalent/core';
import { TdDialogService } from '@covalent/core';

import { Supplier } from '../supplier';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../../../accounting/branch';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { BranchService } from '../../../accounting/branches/branch.service';

@Component({
  selector: 'app-suppliers-new',
  templateUrl: './suppliers-save.component.html',
  styleUrls: ['./suppliers-save.component.scss']
})
export class SuppliersSaveComponent implements OnInit {
  data: Supplier;
  currentSupplier: Supplier;
  currentBranches: Branch[] = [];
  subscription: Subscription = new Subscription();
  //allSuppliers$: Observable<Supplier[]>;
  allBranches: Branch[];
  allCity$: Observable<any[]>;
  branchItem: Branch;
  title: string;
  isEditMode: boolean;

  constructor(private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    private _supplierService: SupplierService,
    private _branchService: BranchService,
    private _locationService: LocationService,
    private route: ActivatedRoute,
    private location: Location,
    public _authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.route.paramMap
      .switchMap(
        (params: ParamMap) => this.mode(params.get('id'))
      )
      .subscribe((currentSupplier: Supplier) => {
        this.currentSupplier = currentSupplier;
        this.currentSupplier.branches = [];

        if (this.currentSupplier.id) {
          this.loadCurrentBranches();
        }

        this._loadingService.resolve('loading');

      });

    //this.allSuppliers$ = this._supplierService.getSuppliers();
    this.allCity$ = this._locationService.getCity();

    this._branchService.getBranches()
      .subscribe((branch: Branch[]) => {
        if (branch && Array.isArray(branch)) {
          this.allBranches = branch;
        } else {
          this.allBranches = [];
        }
      });

  }

  loadCurrentBranches(): void {
    this._branchService
      .getBranchesBySupplier(this.currentSupplier.id)
      .subscribe((branchesBySupplier: any) => {
        this.currentSupplier.branches = Array.isArray(branchesBySupplier.branches)
          ? branchesBySupplier.branches : [];
        this.currentBranches = this.currentSupplier.branches
          ? Object.assign([], branchesBySupplier.branches) : [];
      });
  }

  checkBranch(branchItem: Branch): boolean {
    return (this.currentSupplier && this.currentSupplier.branches)
      ? this.currentSupplier.branches.filter((branch: Branch) => branch.id == branchItem.id).length > 0
      : false;
  }

  selectBranch(event: any, branchItem: any): any {
    this.currentSupplier.branches = this.currentSupplier.branches || [];
    return event.checked
      ? this.currentSupplier.branches.push(branchItem)
      : this.currentSupplier.branches = this.currentSupplier.branches.filter((branch: Branch) => branchItem.id != branch.id);
  }

  goBack(): void {
    this.location.back();
  }

  saveSupplier(isEditMode: boolean): void {
    if (!this.currentSupplier.code) {
      this._dialogService.openAlert({
        message: 'Code field is required',
        title: 'Error',
      });

      return;
    }

    if (!this.currentSupplier.branches || !Array.isArray(this.currentSupplier.branches) || this.currentSupplier.branches.length == 0) {
      this._dialogService.openAlert({
        message: 'At least one branch is required to be checked',
        title: 'Error',
      });

      return;
    }

    this._loadingService.register('loading');

    this.currentSupplier.name = this.currentSupplier.name ? this.currentSupplier.name : '';
    this.currentSupplier.code = this.currentSupplier.code ? this.currentSupplier.code : '';
    this.currentSupplier.contact_person = this.currentSupplier.contact_person ? this.currentSupplier.contact_person : '';
    this.currentSupplier.address = this.currentSupplier.address ? this.currentSupplier.address : '';
    this.currentSupplier.city_id = this.currentSupplier.city_id ? this.currentSupplier.city_id : '1';
    this.currentSupplier.phone = this.currentSupplier.phone ? this.currentSupplier.phone : '';
    this.currentSupplier.fax = this.currentSupplier.fax ? this.currentSupplier.fax : '';
    this.currentSupplier.email = this.currentSupplier.email ? this.currentSupplier.email : '';
    this.currentSupplier.notes = this.currentSupplier.notes ? this.currentSupplier.notes : '';
    this.currentSupplier.branches = this.currentSupplier.branches ? this.currentSupplier.branches : [];

    this._supplierService.saveSupplier(this.currentSupplier)
      .subscribe((savedSupplier: Supplier) => {
        let supplierId = null;
        let branchSize = 0;
        let updateBranches = this.processBranches();
        let branchCalls = [];

        if (this.isEditMode) {
          supplierId = this.currentSupplier.id;
        } else {
          supplierId = savedSupplier.id;
          this.currentSupplier = supplierId;
        }

        if (supplierId && updateBranches.save) {
          updateBranches.save.forEach(save => {
            branchCalls.push(
              this._supplierService
                .saveSupplierBranch(supplierId, save)
                .map((res: Response) => res)
            );
          });
        }

        if (supplierId && updateBranches.delete) {
          updateBranches.delete.forEach(del => {
            branchCalls.push(
              this._supplierService
                .deleteSupplierBranch(supplierId, del)
                .map((res: Response) => res)
            );
          });
        }

        if (branchCalls.length) {
          /* call all branch call */
          Observable.forkJoin(branchCalls).subscribe(data => {
            this.loadSuccess();
          });
        } else {
          this.loadSuccess();
        }

        this._loadingService.resolve('loading');

      },
        error => {
          error = (error.json()['error'] || {});


          this._dialogService.openAlert({
            title: 'Error',
            message: (error['sqlMessage'] || 'Generic error')
          });


          this._loadingService.resolve('loading');
        }
      );

  }

  loadSuccess(): void {
    let name = this.currentSupplier.name || '';
    this._dialogService.openAlert({
      message: 'Successfully '
        + (this.isEditMode ? 'saved' : 'added')
        + ' ' + name + '!',
      title: 'Success',
    }).afterClosed().subscribe((accept: boolean) => {
      if (this.isEditMode) {
        this.loadCurrentBranches();
      } else {
        this.currentSupplier = new Supplier();
      }
    });
  }

  processBranches(): any {
    let newBranches = this.currentSupplier.branches.map(br => br.id);
    let oldBranches = this.currentBranches.map(br => br.id);
    let saveBranches = [];
    let deleteBranches = [];

    newBranches.forEach((br) => {
      if (!~oldBranches.indexOf(br)) {
        saveBranches.push(br);
      }
    });

    oldBranches.forEach((br) => {
      if (!~newBranches.indexOf(br)) {
        deleteBranches.push(br);
      }
    });

    return {
      save: saveBranches,
      delete: deleteBranches
    }
  }

  mode(id: string): Observable<Supplier> {
    if (id) {
      this.title = 'Edit';
      this.isEditMode = true;
      return this._supplierService.getSupplier(parseInt(id));
    }

    this.title = 'New';
    this.isEditMode = false;
    return Observable.of(new Supplier());
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/suppliers/suppliers-save/suppliers-save.component.ts